import { Model } from './model';
import { Specie } from './specie';
import { Zone } from './zone';

export class Stock extends Model {
  id: number;
  name: string;
  pseudonym: string;
  species: Specie[] = [];
  zones: Zone[] = [];
  full_name: string;

  constructor(values: Object = {}) {
    super(values);
  }

  apiMap(values: Object = {}) {
    const stock = new Stock(values);

    stock.full_name = `${stock.name} ${stock.pseudonym}`;

    if (values['species']) {
      for (const specie of values['species']) {
        stock.species.push(new Specie(specie));
      }
    }

    if (values['zones']) {
      for (const zone of values['zones']) {
        stock.zones.push(new Zone(zone));
      }
    }

    return stock;
  }
}



// WEBPACK FOOTER //
// ./src/app/_models/stock.ts